import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDialogType, ReplicateInformationCollection, ReplicateInformationStatus, ReplicateInformationTo } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Branch } from 'src/app/models/branch';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { BranchFilter } from 'src/app/models/filters/branch-filter';
import { ReplicateInformationFilter } from 'src/app/models/filters/replicate-information-filter';
import { Paging } from 'src/app/models/page';
import { ReplicateInformationErrors } from 'src/app/models/replicate-information-errors';
import { SalesOrg } from 'src/app/models/sales-org';
import { BranchesService } from 'src/app/services/branches.service';
import { ReplicateInformationService } from 'src/app/services/replicate-information.service';
import { ReportService } from 'src/app/services/report.service';
import { SalesOrgService } from 'src/app/services/sales-org.service';

@Component({
  selector: 'app-list-replicate-information',
  templateUrl: './list-replicate-information.component.html',
  styleUrls: ['./list-replicate-information.component.sass']
})
export class ListReplicateInformationComponent implements OnInit {

  constructor(private router: Router, private replicateInfoService: ReplicateInformationService, private branchService: BranchesService, private salesOrgService: SalesOrgService, private datePipe: DatePipe, private reportService: ReportService, private confirmService: PosConfirmationService) { }

  logs: Paging<Array<ReplicateInformationErrors>> = new Paging([]);
  branches: Array<Branch> = [];
  salesOrgs: Array<SalesOrg> = [];
  filters: Filter<ReplicateInformationFilter> = { page: 0, pageSize: 15, value: {} };
  async ngOnInit(): Promise<void> {
    this.getLogData(this.filters);
    await this.loadBranches();
    this.salesOrgs = (await this.salesOrgService.readSalesOrgs().toPromise()).response.content;
  }

  private async loadBranches(salesOrg?: string) {
    let branchFilter: Filter<BranchFilter> = { page: 0, pageSize: 5000, value: {} };
    branchFilter.value.salesOrg = salesOrg ?? "";
    this.branches = (await this.branchService
      .readFilteredBranches(branchFilter).toPromise()).response.content;
  }

  getLogHeaders(): Array<ColumnTable> {
    return [new ColumnTable("id", "Código", { isSmall: true }),
    new ColumnTable("collection", "Tipo", { type: 'badge' }),
    new ColumnTable("customerCode", "Código de Cliente"),
    new ColumnTable("date", "Fecha de Creación", { type: "date" }),
    new ColumnTable("sellerCode", "Vendedor"),
    new ColumnTable("seller", "Nombre del Vendedor", { isSmall: true }),
    new ColumnTable("branchCode", "Tienda"),
    // new ColumnTable("invoiceNumber", "Factura"),
    // new ColumnTable("loan", "Contrato"),
    new ColumnTable("status", "Estado", { type: "badge" }),
    new ColumnTable("errorType", "Tipo de Error", { type: "badge" }),
    new ColumnTable("_id", "#", {
      type: "action", iconClass: "fa fa-cogs", isIcon: true, actions: [
        {
          fn: async (log: ReplicateInformationErrors) => {

            const result = await this.confirmService.showAsync("¡Alerta!", `¿Está seguro de reenviar la transacción con código ${log.code}?`, ModalDialogType.WARNING);
            if (result) {
              await this.replicateInfoService.resendReplicateTransaction(log._id).toPromise();

              await this.getLogData(this.filters);
            }
          },
          icon: "text-success fa fa-refresh",
          isDisabled: false,
          disabledFn: (log: ReplicateInformationErrors) => log.status == ReplicateInformationStatus.PROCESSED,
          tooltip: "Reenviar"
        },
        {
          fn: (log: ReplicateInformationErrors) => {

            this.router.navigate(["salesforceTransactions", log._id], {
              state: {
                log
              }
            })
          },
          icon: "fa fa-arrow-right",
          isDisabled: false,
          tooltip: "Ver Detalle"
        }
      ]
    })
    ];
  }

  getProductFilterColumns(): Array<FilterTable> {
    return [
      new FilterTable("id", "Código"),
      new FilterTable("collection", "Tipo", { type: 'combobox', comboBoxFilterValues: this.getCollectionMap() }),
      new FilterTable("status", "Estado", { type: 'combobox', comboBoxFilterValues: this.getStatusMap() }),
      new FilterTable("customerCode", "Código de Cliente"),
      new FilterTable("sellerCode", "Código de Vendedor"),
      new FilterTable("errorType", "Tipo de Error", { type: "combobox", comboBoxFilterValues: this.getErrorTypeMap() }),
      new FilterTable("SalesOrgCode", "Organización", { type: "combobox", comboBoxFilterValues: this.getSalesOrgMap() }),
      new FilterTable("branchCode", "Tienda", { type: 'combobox', comboBoxFilterValues: this.getBranchesMap() }),
      new FilterTable("destination", "Destino del dato", { type: "combobox", comboBoxFilterValues: this.getDestinationMap() }),
      //new FilterTable("startDate", "Fecha inicial", { type: "date" }),
      new FilterTable("endDate", "Fecha Final", { type: "date" }),
    ];
  }
  getErrorTypeMap(): Map<string, string> {
    const result = new Map<string, string>();
    result.set("SELLERWITHOUTBRANCHES", "SELLERWITHOUTBRANCHES");
    result.set("CUSTOMERNOTEXISTS", "CUSTOMERNOTEXISTS");
    result.set("CONTRACTNOTEXISTS", "CONTRACTNOTEXISTS");
    result.set("FISCALIDEMPTY", "FISCALIDEMPTY");
    result.set("OTHER", "OTHER");
    result.set("UPDATEOPORTUNITY", "UPDATEOPORTUNITY");
    result.set("UPDATEORDER", "UPDATEORDER");
    result.set("DATEGREATERTHANALLOW", "DATEGREATERTHANALLOW");
    result.set("JSONPARSERERROR", "JSONPARSERERROR");
    result.set("DATETASKGREATERTHAN", "DATETASKGREATERTHAN");
    result.set("DUEDATELESSTHANNOW", "DUEDATELESSTHANNOW");
    result.set("OPPORTUNITYNOALLOWCHANGE", "OPPORTUNITYNOALLOWCHANGE");
    result.set("PRICEBOOKENTRYNOTFOUND", "PRICEBOOKENTRYNOTFOUND");
    result.set("NAMELONG", "NAMELONG");
    result.set("ORDERNOTFOUND", "ORDERNOTFOUND");
    result.set("UNABLEEXCLUSIVEACCESS", "UNABLEEXCLUSIVEACCESS");
    return result;
  }
  getDestinationMap(): Map<string, string> {
    const result = new Map<string, string>();
    result.set(ReplicateInformationTo.ADOBE_CDP, "Adobe CDP");
    result.set(ReplicateInformationTo.SALESFORCE, "Salesforce");
    return result;

  }

  async getLogData(params: Filter<ReplicateInformationFilter>): Promise<void> {
    await this.loadBranches(params.value.SalesOrgCode);
    let date: Date = new Date();

    if (params.value.endDate == undefined) {
      date = new Date(this.datePipe.transform(date.toDateString(), "yyyy-MM-dd") + " 23:59:59");
      params.value.endDate = this.datePipe.transform(date, "yyyy-MM-dd HH:mm:ssZ") || "";
    }
    else if (params.value.endDate) {
      date = new Date(params.value.endDate.toString().includes(":") ? params.value.endDate.toString() : params.value.endDate.toString() + " 23:59:59");
      params.value.endDate = this.datePipe.transform(date, "yyyy-MM-dd HH:mm:ssZ") || "";
    }

    // minus 3 days
    date.setHours(date.getHours() - 72);
    params.value.startDate = this.datePipe.transform(date, 'yyyy/MM/dd') || "";

    //if search is for Id
    if (params.value.id) {
      params.value.startDate = "";
      params.value.endDate = "";
    }

    params.value.startDate = this.datePipe.transform(params.value.startDate, "yyyy-MM-dd HH:mm:ssZ") || params.value.startDate;
    params.value.endDate = this.datePipe.transform(params.value.endDate, "yyyy-MM-dd HH:mm:ssZ") || params.value.endDate;
    this.logs = (await this.replicateInfoService.readReplicateInformationLog(params).toPromise()).response;
    this.filters = params;
  }

  getCollectionMap() {
    const result = new Map<string, string>();

    result.set(ReplicateInformationCollection.QUOTATION, ReplicateInformationCollection.QUOTATION);
    result.set(ReplicateInformationCollection.ORDER, ReplicateInformationCollection.ORDER);
    result.set(ReplicateInformationCollection.INVOICE, ReplicateInformationCollection.INVOICE);
    result.set(ReplicateInformationCollection.PREAPPROVE, ReplicateInformationCollection.PREAPPROVE);
    result.set(ReplicateInformationCollection.CREATECUSTOMER, ReplicateInformationCollection.CREATECUSTOMER);
    result.set(ReplicateInformationCollection.TICKET, ReplicateInformationCollection.TICKET);
    result.set(ReplicateInformationCollection.CREDITREQUEST, ReplicateInformationCollection.CREDITREQUEST);
    return result;
  }

  private getBranchesMap(): Map<string, string> {
    let result = new Map<string, string>();
    this.branches.forEach(branch => {
      result.set(branch.code, `[${branch.code}] ${branch.name}`);
    });
    return result;
  }

  private getSalesOrgMap(): Map<string, string> {
    let result = new Map<string, string>();
    this.salesOrgs.forEach(salesOrg => {
      result.set(salesOrg.code, `[${salesOrg.code}] ${salesOrg.name}`);
    });
    return result;
  }

  private getStatusMap(): Map<string, string> {
    let result = new Map<string, string>();
    result.set(ReplicateInformationStatus.UNPROCESSED, "Pendiente");
    result.set(ReplicateInformationStatus.PROCESSING, "En Proceso");
    result.set(ReplicateInformationStatus.PROCESSED, "Procesado");
    result.set(ReplicateInformationStatus.FAILED, "Con Error");
    result.set(ReplicateInformationStatus.SKIPED, "Saltados");
    result.set(ReplicateInformationStatus.DELETED, "Eliminados");
    result.set(ReplicateInformationStatus.SENDFORCSV, "Enviados para CSV");
    return result;
  }

  async exportExcel() {
    const report = await this.reportService.replicateInformationLog(this.filters).toPromise();
    await this.reportService.printReport(report);
  }
}
